import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import { Card } from 'reactstrap';
import Spinner from '~/components/spinner/spinner';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getHSCodesQuery = gql`
  query hsCodes($breweryId: Int!) {
    hsCodes(breweryId: $breweryId) {
      id
      name
      description
    }
  }
`;

const HSCodesList = ({ brewery, history }) => (
  <Query query={getHSCodesQuery} variables={{ breweryId: brewery.id }}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      return (
        <Fragment>
          <URLParamBanner name="HS Code" />
          <Card className="content">
            <table className="table mb0">
              <thead>
                <tr>
                  <th className="bt-n bb-n">Name</th>
                  <th className="bt-n bb-n">Description</th>
                </tr>
              </thead>
              <tbody>
                {data.hsCodes.map((code, idx) => (
                  <tr
                    data-qa={`code-${idx}`}
                    className="table-row pointer"
                    key={code.id}
                    onClick={() => {
                      history.push(`/settings/hscodes/${code.id}`);
                    }}
                  >
                    <td>
                      <strong>{code.name}</strong>
                    </td>
                    <td className="mw6">{code.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </Fragment>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(HSCodesList));



// WEBPACK FOOTER //
// ./src/containers/hsCodeList/hsCodeList.jsx